<template>
  <div class="vx-row flex-1">
    <vs-card class="vx-col lg:w-1/4" style="height: 75vh; overflow-y: scroll">
      <h2 class="ml-8 mt-5 pl-12" style="color: red">{{ $t("Reports") }}</h2>
      <div v-for="item in ReportList" :key="item.id" 
           :class="item.id == selectedReport.id ? 'Active' : 'InActive'"
           class="shadow-md w-full mt-2 cursor-pointer">
        <p class="p-3" @click="ReportClick(item)">{{ item.name }}</p>
      </div>
    </vs-card>

    <vs-card class="vx-col lg:w-3/4">
      <div v-if="selectedReport.id" class="vx-row items-end">
        
        <div class="vx-col lg:w-1/3 w-full mb-4">
          <label class="vs-input--label"> {{ $t("SelectInvestor") }}</label>
          <vs-select class="w-full mt-2" v-model="search.InvestorID">
            <vs-select-item :value="null" :text="$t('AllInvestors')" /> 
            <vs-select-item 
              v-for="(item, index) in Investors" 
              :key="index" 
              :value="item.Id" 
              :text="item.UserFullNameAr"  
            />
          </vs-select>
        </div>

        <div v-if="selectedReport.id == 1" class="vx-col lg:w-1/3 w-full mb-4">
          <label class="text-sm opacity-75">{{ $t("KYCStatus") }}</label>
          <v-select 
            class="mt-1"
            :options="KycStatuses" 
            :label="currentLocale === 'ar' ? 'NameAr' : 'NameEn'"  
            v-model="search.InvestorKycStatusId" 
            :reduce="s => s.Id" 
          />
        </div>

        <div class="vx-col lg:w-1/3 w-full mb-4">
          <vs-button 
            color="danger" 
            @click="ViewReport" 
            class="w-full"
          >
            {{ $t("ViewReport") }}
          </vs-button>
        </div>
      </div>

      <div v-else class="text-center p-10">
        <p>الرجاء اختيار تقرير من القائمة الجانبية</p>
      </div>
    </vs-card>
  </div>
</template>

<script>
import vSelect from "vue-select"; 
import moduleInvestors from "@/store/Investors/moduleInvestors.js";

export default {
  components: { vSelect },
  data() {
    return {
      search: {
        InvestorID: null,
        InvestorKycStatusId: null
      },
      selectedReport: {},
      ReportList: [
        { name: this.$t("InvestorReport"), id: 1 },
        { name: this.$t("InvestorOpportunitiesReport"), id: 2 }, 
      ],
    };
  },
  computed: {
    currentLocale() { return this.$i18n.locale; },
    Investors() {   return this.$store.state.InvestorsList.Investors; },
    KycStatuses() { return this.$store.state.InvestorsList.InvestorKYCStatus },
  },
  methods: {
    ReportClick(item) {
      this.selectedReport = item;
      this.search.InvestorID = null;
      this.search.InvestorKycStatusId = null;
    },
    ViewReport() {
      const investorId = this.search.InvestorID || 0;

      if (this.selectedReport.id === 1) {
        const statusId = this.search.InvestorKycStatusId || 0;
        const url = `#/Reports/InvestorReport/${investorId}?statusId=${statusId}`;
        window.open(url, "_blank");
      } 
      else if (this.selectedReport.id === 2) {
    
        const url = `#/Reports/InvestorOpportunities/${investorId}`;
        window.open(url, "_blank");
      }
    }
  },
  created() {
    if (!moduleInvestors.isRegistered) {
      this.$store.registerModule("InvestorsList", moduleInvestors);
      moduleInvestors.isRegistered = true;
    }
    this.$store.dispatch("InvestorsList/fetchDataListItems");
    this.$store.dispatch("InvestorsList/fetchInvestorKycStatus");
  }
};
</script>

<style scoped>
.Active {
  background: #cc1814;
  color: white;
}
.InActive {
  background: #f8f8f8;
}
.cursor-pointer {
  cursor: pointer;
}
</style>